import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import {
  CarouselComponent,
  CarouselControlComponent,
  CarouselIndicatorsComponent,
  CarouselInnerComponent,
  CarouselItemComponent,
  ThemeDirective
} from '@coreui/angular';
import { NgFor } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-carousel',
  standalone: true,
  imports: [
    CarouselComponent,
    CarouselControlComponent,
    CarouselIndicatorsComponent,
    CarouselInnerComponent,
    CarouselItemComponent,
    ThemeDirective,
    NgFor,
    MatButtonModule,
    MatDialogModule,
    CommonModule
  ],
  templateUrl: './image-carousel.component.html',
  styleUrl: './image-carousel.component.scss'
})
export class ImageCarousel implements OnInit {
  image = inject(MAT_DIALOG_DATA);
  slides: any[] = [];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.image?.img?.length) {
      this.slides = this.image.img.map((src: string, index: number) => ({
        id: index,
        src,
        title: `Image ${index + 1}`,
        subtitle: `ImageSub ${index + 1}`
      }));

      // Trigger manual change detection
      this.cdr.detectChanges();
    }
  }
}
